import type { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import type { Observable } from 'rxjs';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NetworkCaptureService } from './network-capture.service';

/**
 * Records failed (status >= 400) requests made via HttpClient for the debug info export.
 * The SDK's own HTTP traffic is captured separately, via rocos-sdk-client.service.ts's
 * hooks.http.onResponse.
 */
@Injectable()
export class NetworkCaptureHttpInterceptor implements HttpInterceptor {
  constructor(private networkCaptureService: NetworkCaptureService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const startedAt = performance.now();

    return next.handle(request).pipe(
      catchError((error: unknown) => {
        if (error instanceof HttpErrorResponse) {
          this.networkCaptureService.record({
            method: request.method,
            url: error.url ?? request.url,
            status: error.status,
            statusText: error.statusText,
            durationMs: Math.round(performance.now() - startedAt),
          });
        }

        return throwError(() => error);
      }),
    );
  }
}
